import React, {Component} from 'react';
import {observer,inject} from "mobx-react";
import { observable, makeObservable } from "mobx";
import { Link } from "react-router-dom";

class UserTriangle extends Component {
  visible=false;

  constructor(props) {
    super(props);
    makeObservable(this,{
      visible:observable
    });
    this._onClickHide=()=>{
      this.visible=false;
      document.removeEventListener("click", this._onClickHide);
    };
  }
  toggleMenu() {
    if(this.visible) {
      this.visible=false;
      setTimeout(()=> {
        document.removeEventListener("click", this._onClickHide);
      }, 300);
    } else {
      this.visible=true;
      setTimeout(()=> {
        document.addEventListener("click", this._onClickHide);
      }, 300);
    }
  }
  render() {
    const t=this.props.translateStore.t.myshelf;
    return (
      <span className="dib pr">
        <span onClick={()=>{ this.toggleMenu(); }} className={`mdi mdi-chevron-down pointer bg-pc1-hover w1-hover ${this.visible?"bg-pc1 w1":""}`}></span>
        {this.visible?(
          <span className="bg-w1 solid1 bo-pc1 pa z4 fs13 lh16" style={{top:'100%', right:0, width: 120 }}>
            {this.props.standalone?(
              <>
                <a href={`/shelf/${this.props.nick}`} className="db w100 hpadd10 tdni pc1 clear bg-pc1-hover w1-hover">{t.M_MAIN2}</a>
                <a href={`/profile/${this.props.nick}`} className="db w100 hpadd10 tdni pc1 clear bg-pc1-hover w1-hover">{t.M_INFO2}</a>
                <a href={`/shelf/${this.props.nick}/all`} className="db w100 hpadd10 tdni pc1 clear bg-pc1-hover w1-hover">{t.M_FIGURES}</a>
                <a href={`/animelist/${this.props.nick}`} className="db w100 hpadd10 tdni pc1 clear bg-pc1-hover w1-hover">{t.M_ANIME}</a>
                <a href={`/blog/${this.props.nick}`} className="db w100 hpadd10 tdni pc1 clear bg-pc1-hover w1-hover">{t.M_BLOG}</a>
                <a href={`/photos/${this.props.nick}/all`} className="db w100 hpadd10 tdni pc1 clear bg-pc1-hover w1-hover">{t.M_PHOTO}</a>
                <a href={`/activity/${this.props.nick}`} className="db w100 hpadd10 tdni pc1 clear bg-pc1-hover w1-hover">{t.M_ACTIVITY}</a>
                <a href={`/market/${this.props.nick}`} className="db w100 hpadd10 tdni pc1 clear bg-pc1-hover w1-hover">{this.props.translateStore.t.evaMarket.store_header}</a>
                <div className="mtop10 mbottom10 dashed1-bottom bo-pc1"></div>
                <a href={`/pm_chat/?to=${this.props.nick}`} className="db w100 hpadd10 tdni pc1 clear bg-pc1-hover w1-hover">{t.M_SEND_PM}</a>
              </>
            ):(
              <>
                <Link to={`/shelf/${this.props.nick}`} className="db w100 hpadd10 tdni pc1 clear bg-pc1-hover w1-hover">{t.M_MAIN2}</Link>
                <Link to={`/profile/${this.props.nick}`} className="db w100 hpadd10 tdni pc1 clear bg-pc1-hover w1-hover">{t.M_INFO2}</Link>
                <Link to={`/shelf/${this.props.nick}/all`} className="db w100 hpadd10 tdni pc1 clear bg-pc1-hover w1-hover">{t.M_FIGURES}</Link>
                <Link to={`/animelist/${this.props.nick}`} className="db w100 hpadd10 tdni pc1 clear bg-pc1-hover w1-hover">{t.M_ANIME}</Link>
                <Link to={`/blog/${this.props.nick}`} className="db w100 hpadd10 tdni pc1 clear bg-pc1-hover w1-hover">{t.M_BLOG}</Link>
                <Link to={`/photos/${this.props.nick}/all`} className="db w100 hpadd10 tdni pc1 clear bg-pc1-hover w1-hover">{t.M_PHOTO}</Link>
                <Link to={`/activity/${this.props.nick}`} className="db w100 hpadd10 tdni pc1 clear bg-pc1-hover w1-hover">{t.M_ACTIVITY}</Link>
                <Link to={`/market/${this.props.nick}`} className="db w100 hpadd10 tdni pc1 clear bg-pc1-hover w1-hover">{this.props.translateStore.t.evaMarket.store_header}</Link>
                <div className="mtop10 mbottom10 dashed1-bottom bo-pc1"></div>
                <Link to={`/pm_chat/?to=${this.props.nick}`} className="db w100 hpadd10 tdni pc1 clear bg-pc1-hover w1-hover">{t.M_SEND_PM}</Link>
              </>
            )}
            {/*
<a class="db fullHovBlue tdn" href="/shelf/PonPon">Shelf</a>
<a class="db fullHovBlue tdn" href="/profile/PonPon">Profile</a>
<a class="db fullHovBlue tdn" href="/shelf/PonPon/all/">Figures</a>
<a class="db fullHovBlue tdn" href="/animelist/PonPon">Anime</a>
<a class="db fullHovBlue tdn" href="/blog/PonPon">Blog</a>
<a class="db fullHovBlue tdn" href="/photos/PonPon/all">Photos</a>
<a class="db fullHovBlue tdn" href="/activity/PonPon">Activity</a>
<a class="db fullHovBlue tdn" href="/shelf/PonPon/feedback/">Feedback</a>
<a class="db fullHovBlue tdn" href="/market/PonPon/">Store</a>
<hr class="separator">
<a class="db fullHovBlue tdn" href="/pm_chat/?to=PonPon">Send PM</a>
            */}

          </span>
        ):null}
      </span>
    )
  }
}

export default inject("translateStore")(observer(UserTriangle));